import { ReactElement } from 'react';

type AlertGraphCellProps = {
  cellValue: number;
  showXAxis?: boolean;
  isSecondary?: boolean;
};

/**
 * Function to get background color of the cell.
 * @param cellValue - Value of cell.
 * @param haveOpacity - Boolean value to check opacity.
 * @returns - String.
 */
const getCellColor = (cellValue: number, haveOpacity?: boolean): string => {
  const COLOR_ERROR = haveOpacity ? 'bg-error-500/50' : 'bg-error-500';
  const COLOR_WARNING = haveOpacity ? 'bg-warning-500/50' : 'bg-warning-500';
  const COLOR_SUCCESS = haveOpacity ? 'bg-success-600/50' : 'bg-success-600';
  if (cellValue > 90) return COLOR_ERROR;
  if (cellValue > 75) return COLOR_WARNING;
  return COLOR_SUCCESS;
};

/**
 * Renders cell for AlertAnalyticsGraph.
 * @param props - Properties of component.
 * @returns - Reactelement.
 */
export default function AlertGraphCell(props: AlertGraphCellProps): ReactElement {
  const { cellValue, showXAxis, isSecondary } = props;
  return (
    <div // eslint-disable-next-line react/no-array-index-key
      className="flex-1"
    >
      <div
        className={`${isSecondary ? 'h-5' : 'h-8'} flex-1 rounded ${getCellColor(
          cellValue,
          isSecondary
        )}`}
      />
      {showXAxis && <div className="text-xs text-gray-500 mt-6 text-center">14:17</div>}
    </div>
  );
}
